import axiosClient from './client'

export const createTransfer = (campaignId) => (
  axiosClient().post(`/campaigns/${campaignId}/transfers`)
)
